import RestService from "@/services/RestService";
const journalMock = {
  students: [
    {
      first_name: "Богдан",
      last_name: "Харченко",
      evaluations: [
        {
          schema__id: 1440,
          lesson__id: 8242,
          evaluation: 10,
          is_completed: null,
        },
        {
          schema__id: 1439,
          lesson__id: 8243,
          evaluation: 2,
          is_completed: null,
        },
        {
          schema__id: 1438,
          lesson__id: 8244,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1437,
          lesson__id: 8245,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1436,
          lesson__id: 8246,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1435,
          lesson__id: 8247,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1434,
          lesson__id: 8248,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1433,
          lesson__id: 8249,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1432,
          lesson__id: 8250,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1431,
          lesson__id: 8251,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1430,
          lesson__id: 8252,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1429,
          lesson__id: 8253,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1428,
          lesson__id: 8254,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1427,
          lesson__id: 8255,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1426,
          lesson__id: 8256,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1425,
          lesson__id: 8257,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1424,
          lesson__id: 8258,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1423,
          lesson__id: 8259,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1422,
          lesson__id: 8260,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1421,
          lesson__id: 8261,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1420,
          lesson__id: 8262,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1419,
          lesson__id: 8263,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1418,
          lesson__id: 8264,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1417,
          lesson__id: 8265,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1416,
          lesson__id: 8266,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1415,
          lesson__id: 8267,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1414,
          lesson__id: 8268,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1413,
          lesson__id: 8531,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1412,
          lesson__id: 8532,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 4574,
          lesson: 3979,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 4577,
          lesson: 3982,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1411,
          lesson: 3913,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 4578,
          lesson: 3983,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1441,
          lesson__id: 10485,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 4579,
          lesson: 3984,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 4580,
          lesson: 3985,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1442,
          lesson__id: 10489,
          evaluation: null,
          is_completed: null,
        },
        {
          schema__id: 1443,
          lesson__id: 10493,
          evaluation: null,
          is_completed: null,
        },
      ],
    },
  ],
  lessons: [
    { name: "1. Повторення", id: 1440, type: 0, semester: 2, order: 1 },
    { name: "2. Вступ", id: 1439, type: 0, semester: 2, order: 2 },
    {
      name: "3. Від «варварських королівств» до імперії франків",
      id: 1438,
      type: 0,
      semester: 2,
      order: 3,
    },
    {
      name: "4. Візантійська імперія",
      id: 1437,
      type: 0,
      semester: 2,
      order: 4,
    },
    { name: "5. Арабський світ.", id: 1436, type: 0, semester: 2, order: 5 },
    {
      name: "6. Практична робота №1.",
      id: 1435,
      type: 0,
      semester: 2,
      order: 6,
    },
    {
      name: "7. Узагальнення. Тематичне оцінювання",
      id: 1434,
      type: 0,
      semester: 2,
      order: 7,
    },
    {
      name: "8. Середньовічна людина.",
      id: 1433,
      type: 0,
      semester: 2,
      order: 8,
    },
    {
      name: "9. Середньовічне європейське суспільство",
      id: 1432,
      type: 0,
      semester: 2,
      order: 9,
    },
    {
      name: "10. Практична робота №2: «Життя й традиції рицарів і селян»",
      id: 1431,
      type: 0,
      semester: 2,
      order: 10,
    },
    {
      name: "11. Узагальнення. Тематичне оцінювання",
      id: 1430,
      type: 0,
      semester: 2,
      order: 11,
    },
    {
      name:
        "12. Скандинавія в добу Середньовіччя. Походи вікінгів та їхні завоювання.",
      id: 1429,
      type: 0,
      semester: 2,
      order: 12,
    },
    { name: "13. Хрестові походи", id: 1428, type: 0, semester: 2, order: 13 },
    {
      name: "14. Практична робота №3: «Наслідки хрестових походів»",
      id: 1427,
      type: 0,
      semester: 2,
      order: 14,
    },
    {
      name:
        "15. Середньовічні держави: від роздробленості до станово-представницьких монархій",
      id: 1426,
      type: 0,
      semester: 2,
      order: 15,
    },
    {
      name: "16. Франція у XI-XV ст.",
      id: 1425,
      type: 0,
      semester: 2,
      order: 16,
    },
    {
      name: "17. Англія у XI-XV ст.",
      id: 1424,
      type: 0,
      semester: 2,
      order: 17,
    },
    {
      name: "18. Священна Римська імперія",
      id: 1423,
      type: 0,
      semester: 2,
      order: 18,
    },
    {
      name: "19. Держави Середземномор’я в Середні віки",
      id: 1422,
      type: 0,
      semester: 2,
      order: 19,
    },
    {
      name: "20. Узагальнення. Тематичне оцінювання",
      id: 1421,
      type: 0,
      semester: 2,
      order: 20,
    },
    {
      name: "21. Наукові і технічні досягнення в Середні віки. Книгодрукування",
      id: 1420,
      type: 0,
      semester: 2,
      order: 21,
    },
    {
      name: "22. Католицька церква в ХІ–V cт.",
      id: 1419,
      type: 0,
      semester: 2,
      order: 22,
    },
    {
      name: "23. Раннє Відродження. Гуманізм",
      id: 1418,
      type: 0,
      semester: 2,
      order: 23,
    },
    {
      name:
        "24. Практична робота №4: «Середньовічні школи та університети. Життя середньовічного студента»",
      id: 1417,
      type: 0,
      semester: 2,
      order: 24,
    },
    {
      name: "25. Архітектура і мистецтво",
      id: 1416,
      type: 0,
      semester: 2,
      order: 25,
    },
    {
      name: "26. Узагальнення. Тематичне оцінювання",
      id: 1415,
      type: 0,
      semester: 2,
      order: 26,
    },
    {
      name: "27. Чернечі лицарські ордени та  християнізація Східної Європи",
      id: 1414,
      type: 0,
      semester: 2,
      order: 27,
    },
    {
      name: "28. Держави Центральної та Східної  Європи в Х–ХV cт",
      id: 1413,
      type: 0,
      semester: 2,
      order: 28,
    },
    {
      name: "29. Землі Північно-Східної Русі в ХІ–ХV cт",
      id: 1412,
      type: 0,
      semester: 2,
      order: 29,
    },
    {
      name: "30. Османська імперія",
      id: 4574,
      type: 0,
      semester: 2,
      order: 31,
    },
    {
      name:
        "31. Практична робота №5: «Виникнення слов’янської писемності. Кирило і Мефодій»",
      id: 4577,
      type: 0,
      semester: 2,
      order: 33,
    },
    {
      name: "32. Узагальнення. Тематичне оцінювання",
      id: 1411,
      type: 0,
      semester: 2,
      order: 35,
    },
    {
      name: "33. Китай та Японія в Середні віки",
      id: 4578,
      type: 0,
      semester: 2,
      order: 35,
    },
    { name: "Семестр 2", id: 1441, type: 3, semester: 2, order: 37 },
    {
      name: "34. Індія в Середні віки",
      id: 4579,
      type: 0,
      semester: 2,
      order: 37,
    },
    {
      name: "35. Узагальнення до курсу",
      id: 4580,
      type: 0,
      semester: 2,
      order: 39,
    },
    { name: "Семестр 2", id: 1442, type: 5, semester: 2, order: 39 },
    { name: "Курс", id: 1443, type: 4, semester: 2, order: 40 },
  ],
};
function listOfCourse() {
  const data = {};
  return RestService.sendReq("get", "course", data);
}

function getLessons(courseId) {
  const data = {};
  return RestService.sendReq("get", `course/${courseId}`, data);
}

function loadJournal() {
  // const data = {};
  // return RestService.sendReq("get", `course/${courseId}`, data);

  return Promise.resolve({
    data: journalMock,
  });
}

export default {
  listOfCourse,
  getLessons,
  loadJournal,
};
